import { gql } from "@/graphql/typed-gql"

export const GET_SUBJECTS = gql`
  query GetSubjects {
    subjects {
      id
      name
      icon
      skills {
        id
        name
        grade
        difficulty
        aiContext
        prerequisites
      }
    }
  }
`

export const GET_SUBJECT = gql`
  query GetSubject($id: ID!) {
    subject(id: $id) {
      id
      name
      icon
      skills {
        id
        name
        grade
        difficulty
        aiContext
        prerequisites
        prerequisiteNames
      }
    }
  }
`

export const GET_AVAILABLE_SKILLS = gql`
  query GetAvailableSkills($studentId: ID!) {
    availableSkills(studentId: $studentId) {
      id
      name
      grade
      subjectKey
      subjectName
      proficiency
      isUnlocked
      exercisesAvailable {
        level1
        level2
        level3
      }
    }
  }
`
